export const userQueryKeys = {
  all: () => "user"
};
